/** @format */

import { Component, computed, inject, ChangeDetectionStrategy } from '@angular/core';

import { ActivatedRoute } from '@angular/router';
import { AuthenticationService } from '@shared/authentication/data-access';
import { Chain } from '@shared/data-access/interfaces';
import { ShopByCategoryComponent } from '../shop-by-category/shop-by-category.component';
import { firstValueFrom } from 'rxjs';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
  selector: 'shared-favorites-components-sign-out',
  templateUrl: './sign-out-favorites.component.html',
  styleUrl: './sign-out-favorites.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [ShopByCategoryComponent],
})
export class SignOutFavoritesComponent {
  private readonly route = inject(ActivatedRoute);
  private readonly authenticationService = inject(AuthenticationService);
  private readonly chain = inject(Chain);
  private readonly routeData = toSignal(this.route.data, {
    initialValue: { isListRoute: false },
  });

  readonly isListRoute = computed(() => Boolean(this.routeData().isListRoute));

  // redirect athletes to signin page
  async signIn(): Promise<void> {
    await firstValueFrom(
      this.authenticationService.login({
        target: this.chain.myAccountUrlLoggedIn,
      }),
    );
  }

  // redirect athletes to  createAccount page
  async createAccount(): Promise<void> {
    await firstValueFrom(this.authenticationService.createAccount());
  }
}
